import { render } from "./Edit.pug?vue&type=template&id=408fe7d3&ts=true&lang=pug&external"
import script from "./Edit.ts?vue&type=script&lang=ts&external"
export * from "./Edit.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/plugins/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "408fe7d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('408fe7d3', __exports__)) {
    api.reload('408fe7d3', __exports__)
  }
  
  module.hot.accept("./Edit.pug?vue&type=template&id=408fe7d3&ts=true&lang=pug&external", () => {
    api.rerender('408fe7d3', render)
  })

}


export default __exports__